'use client'
import React, { useState } from 'react'
import { Fragment } from 'react'
import LinkComponent from '@components/LinkComponent'
import Image from 'next/image'
import { Tab } from '@headlessui/react'
import CurrencySymbol from '@components/CurrencySymbol'
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
import tailwindConfig from '@tailwind.config'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import PropertyCard from '@components/PropertyCard'

const ProjectProperties = ({ name, properties, saleProperties, rentProperties, lang, dictionary }) => {
    const [selectedIndex, setSelectedIndex] = useState(0)

  return (
    <div>
        {(saleProperties > 0 || rentProperties > 0) && (
            <h2 className='text-maincolor text-xl font-semibold mb-1'>{dictionary.property.availableUnitsAt}{name}</h2>
        )}
        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <Tab.List className={`sm:w-1/2 w-full mb-2`}>
                {saleProperties > 0 && (
                    <Tab as={Fragment} className={`w-1/2`}>
                        {({ selected }) => (
                            /* Use the `selected` state to conditionally style the selected tab. */
                            <button
                            className={
                                selected ? `text-md border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-full` : `text-md border-[1px] border-maincolor p-1 rounded-full`
                            }
                            >
                                {dictionary.property.forSale} ({saleProperties})
                            </button>
                        )}
                    </Tab>
                )}
                {rentProperties > 0 && (
                    <Tab as={Fragment} className={`w-1/2`}>
                        {({ selected }) => (
                            /* Use the `selected` state to conditionally style the selected tab. */
                            <button
                            className={
                                selected ? `text-md border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-full` : `text-md border-[1px] border-maincolor p-1 rounded-full`
                            }
                            >
                                {dictionary.property.forRent} ({rentProperties})
                            </button>
                        )}
                    </Tab>
                )}
            </Tab.List>
            <Tab.Panels>
                {saleProperties > 0 && (
                    <Tab.Panel>
                    {properties.map((property, index) => 
                        ((property.saleType == 'sale' || property.saleType == 'salerent') && (
                            // <>
                                <div className='sm:hidden block mt-2' key={property.id}>
                                    <LinkComponent href={`/properties/${property.slug}`}>
                                        <div className='relative w-full aspect-[4/3] rounded-t-md overflow-hidden'>
                                            <Image
                                                // placeholder="blur"
                                                // blurDataURL={property.blur}
                                                // className='object-fit'
                                                className='object-cover'
                                                src={property.cover}
                                                // width={imageWidth}
                                                // height={imageHeight}
                                                fill={true}
                                                alt={property.slug}
                                            />
                                            {(property.videoUrl) ? (
                                                <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap'>
                                                    {/* {(property.foreignQuota && property.category == 'Condo' && property.saleType == 'sale') ? (
                                                        <div className={`rounded-md p-1 text-third border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPlaylistAddCheckCircle /><span className='ml-1'>Foreign Quota</span></div>
                                                    ) : null} */}
                                                    {property.videoUrl ? (
                                                        <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                                    ) : null}
                                                    {/* {property.isSeaView ? (
                                                        <div className={`rounded-md p-1 bg-maincolor text-light border-light border-[1px] text-sm mr-1 flex flex-row items-center`}><FaWater /><span className='ml-1'>{dictionary.seaView}</span></div>
                                                    ) : null} */}
                                                    {/* {property.isBeachfront ? (
                                                        <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdBeachAccess /><span className='ml-1'>{dictionary.beachfront}</span></div>
                                                    ) : null} */}
                                                    {/* {property.isMountainView ? (
                                                        <div className={`rounded-md p-1 text-secondary border-secondary border-[1px] text-sm mr-1 flex flex-row items-center`}><FaMountain /><span className='ml-1'>Mountain View</span></div>
                                                    ) : null} */}
                                                </div>
                                            ) : null}
                                            {/* {property.publicTransport ? (
                                                <div className='absolute flex flex-row flex-wrap bottom-0 left-0'>
                                                    {property.publicTransport.map((transport, index) => (
                                                        <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-1 mb-1`}>{transport.type.toUpperCase()} {transport.stationName}</div>
                                                    ))}
                                                </div>
                                            ) : null} */}
                                        </div>
                                        <div className='p-2'>
                                            {/* <div className='text-maincolor text-xl font-semibold rounded-r-md z-10'><h3>{property.category} for {property.saleType !== 'salerent' ? property.saleType : 'Sale and Rent'}</h3></div> */}
                                            <div className='text-maincolor text-xl font-semibold rounded-r-md z-10 h-[60px]'><h3 className='line-clamp-2'>{property.name}</h3></div>
                                            {property.oldSalePrice && (
                                                <div className='line-through text-gray-400 flex flex-row'><CurrencySymbol />{property.oldSalePrice}</div>
                                            )}
                                            <div className='flex sm:flex-row flex-col w-full '>
                                                {property.salePrice && (
                                                    <div className='text-xl font-semibold text-third w-1/2'><CurrencySymbol />{property.salePrice}</div>
                                                )}
                                            </div>
                                            {/* <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                                                <p className='text-secondary text-xl'>{property.districts[0]?.subdistrictName?.[lang] ? property.districts[0]?.subdistrictName?.[lang] : property.districts[0]?.subdistrict}</p>
                                            </div> */}
                                            {(property.metaCategory == 'Condo' || property.metaCategory == 'House') &&
                                                <div className='flex flex-row w-full'>
                                                    <div className='flex flex-row items-center w-1/2'>
                                                        <FaBed
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                        />
                                                        <span className='ml-2 text-xl text-maincolor'>{property.bedrooms} {dictionary.card.beds}</span>
                                                    </div>
                                                    <div className='flex flex-row items-center w-1/2'>
                                                        <FaBath
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                        />
                                                        <span className='ml-2 text-xl text-maincolor'>{property.bathrooms} {dictionary.card.baths}</span>
                                                    </div>
                                                </div>

                                            }
                                            <div className='flex flex-row w-full justify-between'>
                                                {(property.metaCategory !== 'Land' || property.livingArea > 0) &&
                                                    <div className='flex flex-row items-center w-1/2'>
                                                        <BiArea
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                        />
                                                        <span className='ml-2 text-xl text-maincolor'>{property.livingArea} {dictionary.card.sqm}</span>
                                                    </div>
                                                }
                                                {(property.metaCategory == 'Land' || property.landArea > 0) &&
                                                    <div className='flex flex-row items-center w-1/2'>
                                                        <BiSolidArea
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                        />
                                                        <span className='ml-2 text-xl text-maincolor'>{property.landArea} {dictionary.card.sqm}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </LinkComponent>
                                </div>
                            // </>
                        ))
                    )}
                    <div className="sm:block hidden">
                        <Swiper
                            spaceBetween={10}
                            slidesPerView={3}
                            pagination={{ clickable: true }}
                            navigation={true}
                            modules={[Navigation]}
                            className=""
                        >
                            {properties.map((property, index) =>
                            (property.saleType === "sale" || property.saleType === "salerent") && (
                                <SwiperSlide key={index}>
                                <PropertyCard
                                    property={property}
                                    dictionary={dictionary.card}
                                    lang={lang}
                                />
                                </SwiperSlide>
                            )
                            )}
                        </Swiper>
                    </div>

                    </Tab.Panel>
                )}
                {rentProperties > 0 && (
                    <Tab.Panel>
                    {properties.map((property, index) => 
                        ((property.saleType == 'rent' || property.saleType == 'salerent') && (
                            <div className='sm:hidden block mt-2' key={property.id}>
                                <LinkComponent href={`/properties/${property.slug}`}>
                                    <div className='relative w-full aspect-[4/3] rounded-t-md overflow-hidden'>
                                        <Image
                                            // placeholder="blur"
                                            // blurDataURL={property.blur}
                                            // className='object-fit'
                                            className='object-cover'
                                            src={property.cover}
                                            // width={imageWidth}
                                            // height={imageHeight}
                                            fill={true}
                                            alt={property.slug}
                                        />
                                        {(property.videoUrl) ? (
                                            <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap'>
                                                {/* {(property.foreignQuota && property.category == 'Condo' && property.saleType == 'sale') ? (
                                                    <div className={`rounded-md p-1 text-third border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPlaylistAddCheckCircle /><span className='ml-1'>Foreign Quota</span></div>
                                                ) : null} */}
                                                {property.videoUrl ? (
                                                    <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                                ) : null}
                                                {/* {property.isSeaView ? (
                                                    <div className={`rounded-md p-1 bg-maincolor text-light border-light border-[1px] text-sm mr-1 flex flex-row items-center`}><FaWater /><span className='ml-1'>{dictionary.seaView}</span></div>
                                                ) : null} */}
                                                {/* {property.isBeachfront ? (
                                                    <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdBeachAccess /><span className='ml-1'>{dictionary.beachfront}</span></div>
                                                ) : null} */}
                                                {/* {property.isMountainView ? (
                                                    <div className={`rounded-md p-1 text-secondary border-secondary border-[1px] text-sm mr-1 flex flex-row items-center`}><FaMountain /><span className='ml-1'>Mountain View</span></div>
                                                ) : null} */}
                                            </div>
                                        ) : null}
                                        {/* {property.publicTransport ? (
                                            <div className='absolute flex flex-row flex-wrap bottom-0 left-0'>
                                                {property.publicTransport.map((transport, index) => (
                                                    <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-1 mb-1`}>{transport.type.toUpperCase()} {transport.stationName}</div>
                                                ))}
                                            </div>
                                        ) : null} */}
                                    </div>
                                    <div className='p-2'>
                                        {/* <div className='text-maincolor text-xl font-semibold rounded-r-md z-10'><h3>{property.category} for {property.saleType !== 'salerent' ? property.saleType : 'Sale and Rent'}</h3></div> */}
                                        <div className='text-maincolor text-xl font-semibold rounded-r-md z-10 h-[60px]'><h3 className='line-clamp-2'>{property.name}</h3></div>
                                        {property.oldRentPrice && (
                                            <div className='line-through text-gray-400 flex flex-row'><CurrencySymbol />{property.oldRentPrice}{dictionary.card.perMonth}</div>
                                        )}
                                        <div className='flex sm:flex-row flex-col w-full '>
                                            {property.rentPrice && (
                                                <div className='text-xl font-semibold text-third w-1/2'><CurrencySymbol />{property.rentPrice}{dictionary.card.perMonth}</div>
                                            )}
                                        </div>
                                        {/* <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                                            <p className='text-secondary text-xl'>{property.districts[0]?.subdistrictName?.[lang] ? property.districts[0]?.subdistrictName?.[lang] : property.districts[0]?.subdistrict}</p>
                                        </div> */}
                                        {(property.metaCategory == 'Condo' || property.metaCategory == 'House') &&
                                            <div className='flex flex-row w-full'>
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <FaBed
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2 text-xl text-maincolor'>{property.bedrooms} {dictionary.card.beds}</span>
                                                </div>
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <FaBath
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2 text-xl text-maincolor'>{property.bathrooms} {dictionary.card.baths}</span>
                                                </div>
                                            </div>

                                        }
                                        <div className='flex flex-row w-full justify-between'>
                                            {(property.metaCategory !== 'Land' || property.livingArea > 0) &&
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <BiArea
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2 text-xl text-maincolor'>{property.livingArea} {dictionary.card.sqm}</span>
                                                </div>
                                            }
                                            {(property.category == 'Land' || property.landArea > 0) &&
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <BiSolidArea
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2 text-xl text-maincolor'>{property.landArea} {dictionary.sqm}</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </LinkComponent>
                            </div>
                        ))
                    )}
                    <div className="sm:block hidden">
                        <Swiper
                            spaceBetween={10}
                            slidesPerView={3}
                            pagination={{ clickable: true }}
                            navigation={true}
                            modules={[Navigation]}
                            className=""
                        >
                            {properties.map((property, index) =>
                            (property.saleType === "rent" || property.saleType === "salerent") && (
                                <SwiperSlide key={index}>
                                <PropertyCard
                                    property={property}
                                    dictionary={dictionary.card}
                                    lang={lang}
                                />
                                </SwiperSlide>
                            )
                            )}
                        </Swiper>
                    </div>
                    </Tab.Panel>
                )}
            </Tab.Panels>
        </Tab.Group>
        <div>

        </div>
    </div>
  )
}

export default ProjectProperties
// 'use client'
// import React, { useState } from 'react'
// import { Fragment } from 'react'
// import LinkComponent from '@components/LinkComponent'
// import Image from 'next/image'
// import { Tab } from '@headlessui/react'
// import { BiSolidBed, BiSolidBath } from "react-icons/bi"
// import { AiOutlineLayout } from "react-icons/ai"
// import tailwindConfig from '@tailwind.config'
// import CurrencySymbol from '@components/CurrencySymbol'

// const ProjectProperties = ({ properties, saleProperties, rentProperties, lang, dictionary }) => {
//     const [selectedIndex, setSelectedIndex] = useState(0)

//   return (
//     <div className='sm:mt-0 mt-4'>
//         <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
//             <Tab.List className={`sm:w-1/2 w-full mb-2`}>
//                 <Tab as={Fragment} className={`w-1/2`}>
//                     {({ selected }) => (
//                         /* Use the `selected` state to conditionally style the selected tab. */
//                         <button
//                         className={
//                             selected ? `border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-full` : `border-[1px] border-maincolor text-maincolor p-1 rounded-full`
//                         }
//                         >
//                             {dictionary.forSale} ({saleProperties})
//                         </button>
//                     )}
//                 </Tab>
//                 <Tab as={Fragment} className={`w-1/2`}>
//                     {({ selected }) => (
//                         /* Use the `selected` state to conditionally style the selected tab. */
//                         <button
//                         className={
//                             selected ? `border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-full` : `border-[1px] border-maincolor text-maincolor p-1 rounded-full`
//                         }
//                         >
//                             {dictionary.forRent} ({rentProperties})
//                         </button>
//                     )}
//                 </Tab>
//             </Tab.List>
//             <Tab.Panels className='mb-2'>
//                 <Tab.Panel>
//                 {properties.map((property, index) => 
//                     ((property.saleType == 'sale' || property.saleType == 'salerent') && (
//                         <LinkComponent key={property.id} href={`/properties/${property.slug}`}>
//                             <div className='w-full flex flex-row items-center text-maincolor py-2'>
//                                 <div className='relative w-[120px] aspect-[4/3] flex-shrink-0 rounded-xl overflow-hidden'>
//                                     <Image
//                                         // placeholder="blur"
//                                         // blurDataURL={property.blur}
//                                         // className='object-fit'
//                                         className='object-cover cursor-pointer hover:shadow-xl'
//                                         src={property.cover}
//                                         // width={imageWidth}
//                                         // height={imageHeight}
//                                         fill={true}
//                                         // alt={property.slug}
//                                     />
//                                 </div>
//                                 <div className='w-full flex sm:flex-row flex-col ml-4 items-center'>
//                                     <div className='flex-col sm:w-1/3 w-full flex-shrink-0 overflow-x-clip line-clamp-3'>
//                                         <span className='text-third font-semibold'><CurrencySymbol lang={lang} />{property.salePrice}</span>
//                                         <p className=' sm:flex hidden'>{property.name}</p>
//                                     </div>
//                                     <div className='flex flex-row w-full justify-between sm:ml-4 ml-0'>
//                                         <div className='flex sm:flex-col flex-row sm:items-start items-center'>
//                                             <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
//                                             <BiSolidBed
//                                                 size={16}
//                                                 color={tailwindConfig.theme.extend.colors.maincolor}
//                                                 className='sm:hidden block sm:ml-0 ml-2'
//                                             />
//                                             <p className='sm:block hidden'>{dictionary.beds}</p>
//                                         </div>
//                                         <div className='flex sm:flex-col flex-row sm:items-start items-center'>
//                                             <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
//                                             <BiSolidBath
//                                                 size={16}
//                                                 color={tailwindConfig.theme.extend.colors.maincolor}
//                                                 className='sm:hidden block sm:ml-0 ml-2'
//                                             />
//                                             <p className='sm:block hidden'>{dictionary.baths}</p>
//                                         </div>
//                                         <div className='flex sm:flex-col flex-row sm:items-start items-center'>
//                                             <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
//                                             <AiOutlineLayout
//                                                 size={16}
//                                                 color={tailwindConfig.theme.extend.colors.maincolor}
//                                                 className='sm:hidden block sm:ml-0 ml-2'
//                                             />
//                                             <p className='sm:block hidden'>{dictionary.sqm}</p>
//                                         </div>
//                                         <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-full'>{dictionary.view}</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </LinkComponent>
//                     ))
//                 )}
//                 </Tab.Panel>
//                 <Tab.Panel>
//                 {properties.map((property, index) => 
//                     ((property.saleType == 'rent' || property.saleType == 'salerent') && (
//                         <LinkComponent key={property.id} href={`/properties/${property.slug}`}>
//                             <div className='w-full flex flex-row items-center text-maincolor py-2'>
//                                 <div className='relative w-[120px] aspect-[4/3] flex-shrink-0 rounded-xl overflow-hidden'>
//                                     <Image
//                                         // placeholder="blur"
//                                         // blurDataURL={property.blur}
//                                         // className='object-fit'
//                                         className='object-cover cursor-pointer hover:shadow-xl'
//                                         src={property.cover}
//                                         // width={imageWidth}
//                                         // height={imageHeight}
//                                         fill={true}
//                                         // alt={property.slug}
//                                     />
//                                 </div>
//                                 <div className='w-full flex sm:flex-row flex-col ml-4 items-center'>
//                                     <div className='flex-col sm:w-1/3 w-full flex-shrink-0 overflow-x-clip line-clamp-3'>
//                                         <span className='text-third font-semibold'><CurrencySymbol lang={lang} />{property.rentPrice}/{dictionary.month}</span>
//                                         <p className=' sm:flex hidden'>{property.name}</p>
//                                     </div>
//                                     <div className='flex flex-row w-full justify-between sm:ml-4 ml-0'>
//                                         <div className='flex sm:flex-col flex-row sm:items-start items-center'>
//                                             <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
//                                             <BiSolidBed
//                                                 size={16}
//                                                 color={tailwindConfig.theme.extend.colors.maincolor}
//                                                 className='sm:hidden block sm:ml-0 ml-2'
//                                             />
//                                             <p className='sm:block hidden'>{dictionary.beds}</p>
//                                         </div>
//                                         <div className='flex sm:flex-col flex-row sm:items-start items-center'>
//                                             <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
//                                             <BiSolidBath
//                                                 size={16}
//                                                 color={tailwindConfig.theme.extend.colors.maincolor}
//                                                 className='sm:hidden block sm:ml-0 ml-2'
//                                             />
//                                             <p className='sm:block hidden'>{dictionary.baths}</p>
//                                         </div>
//                                         <div className='flex sm:flex-col flex-row sm:items-start items-center'>
//                                             <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
//                                             <AiOutlineLayout
//                                                 size={16}
//                                                 color={tailwindConfig.theme.extend.colors.maincolor}
//                                                 className='sm:hidden block sm:ml-0 ml-2'
//                                             />
//                                             <p className='sm:block hidden'>{dictionary.sqm}</p>
//                                         </div>
//                                         <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-full'>{dictionary.view}</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </LinkComponent>

//                 )))}
//                 </Tab.Panel>
//             </Tab.Panels>
//         </Tab.Group>
//         <div>

//         </div>
//     </div>
//   )
// }

// export default ProjectProperties